export const OVERTIME_FORM_FIELDS = ['employeeId', 'toDate', 'type', 'isOnVacation', 'workTime'];

export enum OvertimeFormFields {
  employeeId = 'employeeId',
  toDate = 'toDate',
  type = 'type',
  isOnVacation = 'isOnVacation',
  signatory = 'signatory',
  orderNumber = 'orderNumber',
  orderDate = 'orderDate',
  workTime = 'workTime',
}

export const WORK_TIME_OVER_MESSAGE_OVERTIME = 'Сверхурочные должны быть не больше 4 часов';
export const NOT_PROVIDED_DATE_OVERTIME = 'Введите дату работы сверхурочно';
export const NOT_PROVIDED_TIME_OVERTIME = 'Проверьте время работы';
